import React, { useState } from 'react';
import { ArrowRight, ChevronDown, CheckCircle, Sparkles, UtensilsCrossed } from 'lucide-react';

const DemoOnlyPage = () => {
  const [language, setLanguage] = useState('fi');
  const [step, setStep] = useState(0);
  const [guests, setGuests] = useState(50);
  const [expandedWeddingMenu, setExpandedWeddingMenu] = useState(null);
  const [expandedCategory, setExpandedCategory] = useState(null);
  const [selections, setSelections] = useState({
    eventType: '',
    weddingChoice: null,
    weddingMenu: null,
    salads: [],
    mainCourses: [],
    sides: [],
    breads: [],
    desserts: [],
    drinks: [],
    services: [],
    delivery: null
  });

  // Translations
  const t = language === 'fi' ? {
    title: 'Pitopalvelulaskuri - Demo',
    eventQuestion: 'Millainen tilaisuus?',
    wedding: 'Häät', birthday: 'Syntymäpäivät', memorial: 'Muistotilaisuus', corporate: 'Yritysjuhlat',
    guestsQuestion: 'Montako vierasta?', minGuests: 'Vähintään 10 henkilöä',
    menuChoice: 'Miten rakennetaan menu?', menuChoiceDesc: 'Valitse valmis häämenu tai kokoa itse',
    readyMenu: 'Valmis häämenu', readyMenuDesc: 'Valitse valmiista menupaketeista',
    customMenu: 'Rakennan itse menun', customMenuDesc: 'Valitse ruoat yksitellen',
    selectWeddingMenu: 'Valitse häämenu', weddingMenuDesc: 'Valmiit menuvaihtoehdot häihin',
    selectSalads: 'Valitse salaatit', selectMultiple: 'Voit valita useamman',
    selectMainCourse: 'Valitse pääruoat', mainCourseDesc: 'Valitse kategorioista',
    selectSides: 'Valitse lisukkeet', sidesDesc: 'Voit valita useamman',
    selectBreads: 'Valitse leivät', breadsDesc: 'Voit valita useamman',
    dessertQuestion: 'Jälkiruoat', drinksQuestion: 'Juomat',
    additionalServices: 'Lisäpalvelut', deliveryQuestion: 'Toimitus', deliveryDesc: 'Toimitetaanko ruoat perille?',
    yes: 'Kyllä', no: 'Ei', pickup: 'Nouto', summary: 'Yhteenveto',
    eventType: 'Tilaisuus', guestCount: 'Henkilömäärä', persons: 'hlö', weddingMenu: 'Häämenu',
    salads: 'Salaatit', sides: 'Lisukkeet', breads: 'Leivät', pcs: 'kpl', mainCourse: 'Pääruoat', dessert: 'Jälkiruoat', drinks: 'Juomat', delivery: 'Toimitus',
    total: 'Yhteensä', demoNote: 'Demo - oikea laskuri räätälöidään sinun hinnoitteluusi',
    previous: 'Edellinen', next: 'Seuraava', startOver: 'Aloita alusta',
    pork: 'Possu', beef: 'Nauta', chicken: 'Kana', fish: 'Kala', vegetarian: 'Kasvis',
    perPerson: '/hlö', selected: 'Valittu:',
    poweredBy: 'Powered by'
  } : {
    title: 'Catering Calculator - Demo',
    eventQuestion: 'What kind of event?',
    wedding: 'Wedding', birthday: 'Birthday', memorial: 'Memorial', corporate: 'Corporate event',
    guestsQuestion: 'How many guests?', minGuests: 'Minimum 10 people',
    menuChoice: 'How to build the menu?', menuChoiceDesc: 'Choose a ready wedding menu or build your own',
    readyMenu: 'Ready wedding menu', readyMenuDesc: 'Choose from ready menu packages',
    customMenu: 'Build my own menu', customMenuDesc: 'Select dishes individually',
    selectWeddingMenu: 'Select wedding menu', weddingMenuDesc: 'Ready menu options for weddings',
    selectSalads: 'Select salads', selectMultiple: 'You can select multiple',
    selectMainCourse: 'Select main courses', mainCourseDesc: 'Choose from categories',
    selectSides: 'Select sides', sidesDesc: 'You can select multiple',
    selectBreads: 'Select breads', breadsDesc: 'You can select multiple',
    dessertQuestion: 'Desserts', drinksQuestion: 'Drinks',
    additionalServices: 'Additional services', deliveryQuestion: 'Delivery', deliveryDesc: 'Should we deliver the food?',
    yes: 'Yes', no: 'No', pickup: 'Pickup', summary: 'Summary',
    eventType: 'Event', guestCount: 'Guest count', persons: 'ppl', weddingMenu: 'Wedding menu',
    salads: 'Salads', sides: 'Sides', breads: 'Breads', pcs: 'pcs', mainCourse: 'Main courses', dessert: 'Desserts', drinks: 'Drinks', delivery: 'Delivery',
    total: 'Total', demoNote: 'Demo - the real calculator is customized to your pricing',
    previous: 'Previous', next: 'Next', startOver: 'Start over',
    pork: 'Pork', beef: 'Beef', chicken: 'Chicken', fish: 'Fish', vegetarian: 'Vegetarian',
    perPerson: '/person', selected: 'Selected:',
    poweredBy: 'Powered by'
  };

  const eventTypes = [
    { value: 'haat', label: t.wedding },
    { value: 'synttarit', label: t.birthday },
    { value: 'muistotilaisuus', label: t.memorial },
    { value: 'yritysjuhlat', label: t.corporate }
  ];

  const weddingMenus = [
    { id: 'klassinen', name: language === 'fi' ? 'Klassinen häämenu' : 'Classic wedding menu', description: language === 'fi' ? 'Perinteinen ja tyylikäs' : 'Traditional and elegant', pricePerPerson: 65, items: [language === 'fi' ? 'Alkupalat' : 'Starters', language === 'fi' ? 'Lohta & Naudan sisäfilettä' : 'Salmon & Beef tenderloin', language === 'fi' ? 'Jälkiruoka' : 'Dessert'] },
    { id: 'moderni', name: language === 'fi' ? 'Moderni häämenu' : 'Modern wedding menu', description: language === 'fi' ? 'Raikas ja nykyaikainen' : 'Fresh and contemporary', pricePerPerson: 72, items: [language === 'fi' ? 'Tapas-alkupalat' : 'Tapas starters', language === 'fi' ? 'Karitsan karetta & Kuhaa' : 'Lamb rack & Pike-perch', language === 'fi' ? 'Petit fours' : 'Petit fours'] },
    { id: 'gourmet', name: language === 'fi' ? 'Gourmet häämenu' : 'Gourmet wedding menu', description: language === 'fi' ? 'Premium-vaihtoehto' : 'Premium option', pricePerPerson: 89, items: [language === 'fi' ? 'Amuse bouche' : 'Amuse bouche', language === 'fi' ? 'Hummeribisque' : 'Lobster bisque', language === 'fi' ? 'Wagyu & Tryffeliä' : 'Wagyu & Truffle', language === 'fi' ? 'Jälkiruokatrio' : 'Dessert trio'] },
    { id: 'kasvis', name: language === 'fi' ? 'Kasvis häämenu' : 'Vegetarian wedding menu', description: language === 'fi' ? 'Kasvispohjainen juhlamenu' : 'Plant-based celebration menu', pricePerPerson: 58, items: [language === 'fi' ? 'Kauden kasviksia' : 'Seasonal vegetables', language === 'fi' ? 'Sienirisotto & Juureksia' : 'Mushroom risotto & Root vegetables', language === 'fi' ? 'Suklaamoussea' : 'Chocolate mousse'] }
  ];

  const saladOptions = [
    { value: 'vihersalaatti', label: language === 'fi' ? 'Vihersalaatti' : 'Green salad' },
    { value: 'caesarsalaatti', label: language === 'fi' ? 'Caesarsalaatti' : 'Caesar salad' },
    { value: 'perunasalaatti', label: language === 'fi' ? 'Perunasalaatti' : 'Potato salad' },
    { value: 'punajuurisalaatti', label: language === 'fi' ? 'Punajuurisalaatti' : 'Beetroot salad' }
  ];

  const mainCourseCategories = [
    { id: 'pork', label: t.pork, dishes: [
      { value: 'porsaanpaisti', label: language === 'fi' ? 'Porsaanpaisti' : 'Roast pork' },
      { value: 'kyljykset', label: language === 'fi' ? 'Kyljykset' : 'Pork chops' },
      { value: 'pulled-pork', label: 'Pulled pork' },
      { value: 'possun-ulkofilee', label: language === 'fi' ? 'Possun ulkofilee' : 'Pork tenderloin' }
    ]},
    { id: 'beef', label: t.beef, dishes: [
      { value: 'harkaa-burgundilaisittain', label: language === 'fi' ? 'Härkää burgundilaisittain' : 'Beef Bourguignon' },
      { value: 'paahtopaisti', label: language === 'fi' ? 'Paahtopaisti' : 'Roast beef' },
      { value: 'naudan-sisafilee', label: language === 'fi' ? 'Naudan sisäfilee' : 'Beef tenderloin' },
      { value: 'lihapullat', label: language === 'fi' ? 'Lihapullat' : 'Meatballs' }
    ]},
    { id: 'chicken', label: t.chicken, dishes: [
      { value: 'kanan-koipireisi', label: language === 'fi' ? 'Kanan koipi-reisi' : 'Chicken leg-thigh' },
      { value: 'kanaa-kerma', label: language === 'fi' ? 'Kanaa kermakastikkeessa' : 'Chicken in cream sauce' },
      { value: 'broilerin-rinta', label: language === 'fi' ? 'Broilerin rinta' : 'Chicken breast' },
      { value: 'kalkkunaa', label: language === 'fi' ? 'Kalkkunaa' : 'Turkey' }
    ]},
    { id: 'fish', label: t.fish, dishes: [
      { value: 'lohta-sitruuna', label: language === 'fi' ? 'Lohta sitruunakastikkeessa' : 'Salmon with lemon sauce' },
      { value: 'siika', label: language === 'fi' ? 'Siikaa' : 'Whitefish' },
      { value: 'kuha', label: language === 'fi' ? 'Kuhaa' : 'Pike-perch' },
      { value: 'kirjolohi', label: language === 'fi' ? 'Kirjolohta' : 'Rainbow trout' }
    ]},
    { id: 'vegetarian', label: t.vegetarian, dishes: [
      { value: 'kasvislasagne', label: language === 'fi' ? 'Kasvislasagne' : 'Vegetable lasagna' },
      { value: 'taytettya-paprikaa', label: language === 'fi' ? 'Täytettyä paprikaa' : 'Stuffed peppers' },
      { value: 'falafel', label: 'Falafel' },
      { value: 'kasviskeitto', label: language === 'fi' ? 'Kasviskeitto' : 'Vegetable soup' }
    ]}
  ];

  const sideOptions = [
    { value: 'keitetyt-perunat', label: language === 'fi' ? 'Keitetyt perunat' : 'Boiled potatoes' },
    { value: 'valkosipuliperunat', label: language === 'fi' ? 'Valkosipuliperunat' : 'Garlic potatoes' },
    { value: 'lohkoperunat', label: language === 'fi' ? 'Lohkoperunat' : 'Wedge potatoes' },
    { value: 'kauden-kasvikset', label: language === 'fi' ? 'Kauden kasvikset' : 'Seasonal vegetables' }
  ];

  const breadOptions = [
    { value: 'ruisleipa', label: language === 'fi' ? 'Ruisleipä' : 'Rye bread' },
    { value: 'patonki', label: language === 'fi' ? 'Patonki' : 'Baguette' },
    { value: 'focaccia', label: 'Focaccia' },
    { value: 'saaristolaisleipa', label: language === 'fi' ? 'Saaristolaisleipä' : 'Archipelago bread' }
  ];

  const dessertOptions = [
    { value: 'mokkapala', label: language === 'fi' ? 'Mokkapala' : 'Mocha square' },
    { value: 'taytekakku', label: language === 'fi' ? 'Täytekakku' : 'Layer cake' },
    { value: 'juustokakku', label: language === 'fi' ? 'Juustokakku' : 'Cheesecake' },
    { value: 'munkkibuffa', label: language === 'fi' ? 'Munkkibuffa' : 'Donut buffet' },
    { value: 'pannukakku', label: language === 'fi' ? 'Pannukakku' : 'Pancake' },
    { value: 'marjakiisseli', label: language === 'fi' ? 'Marjakiisseli' : 'Berry pudding' }
  ];

  const drinkOptions = [
    { value: 'mehu', label: language === 'fi' ? 'Mehu' : 'Juice' },
    { value: 'kotikalja', label: language === 'fi' ? 'Kotikalja' : 'Home-brewed beer' },
    { value: 'kahvi', label: language === 'fi' ? 'Kahvi' : 'Coffee' },
    { value: 'tee', label: language === 'fi' ? 'Tee' : 'Tea' }
  ];

  const serviceOptions = [
    { id: 'tarjoilu', label: language === 'fi' ? 'Tarjoiluhenkilökunta' : 'Serving staff' },
    { id: 'kattaus', label: language === 'fi' ? 'Kattauspalvelu' : 'Table setting service' },
    { id: 'astiat', label: language === 'fi' ? 'Astiat' : 'Dishes/tableware' }
  ];

  const prices = {
    salads: { 'vihersalaatti': 3.5, 'caesarsalaatti': 4.5, 'perunasalaatti': 3, 'punajuurisalaatti': 3.5 },
    mains: { 
      'porsaanpaisti': 12.5, 'kyljykset': 13, 'pulled-pork': 11, 'possun-ulkofilee': 14,
      'harkaa-burgundilaisittain': 16.5, 'paahtopaisti': 15, 'naudan-sisafilee': 22, 'lihapullat': 11,
      'kanan-koipireisi': 12.5, 'kanaa-kerma': 12, 'broilerin-rinta': 13, 'kalkkunaa': 14,
      'lohta-sitruuna': 16.5, 'siika': 15, 'kuha': 17, 'kirjolohi': 14,
      'kasvislasagne': 10.5, 'taytettya-paprikaa': 11, 'falafel': 10, 'kasviskeitto': 9
    },
    sides: { 'keitetyt-perunat': 2, 'valkosipuliperunat': 2.5, 'lohkoperunat': 2.5, 'kauden-kasvikset': 3 },
    breads: { 'ruisleipa': 1.5, 'patonki': 2, 'focaccia': 2.5, 'saaristolaisleipa': 2 },
    desserts: { 'mokkapala': 2, 'taytekakku': 4.5, 'juustokakku': 4.5, 'munkkibuffa': 3, 'pannukakku': 3, 'marjakiisseli': 2.5 },
    drinks: { 'mehu': 1, 'kotikalja': 1, 'kahvi': 2.5, 'tee': 2 },
    services: { 'tarjoilu': 200, 'kattaus': 1.5, 'astiat': 3 },
    delivery: 50
  };

  // Toggle functions
  const toggleSalad = (saladValue) => {
    setSelections(prev => ({
      ...prev,
      salads: prev.salads.includes(saladValue)
        ? prev.salads.filter(s => s !== saladValue)
        : [...prev.salads, saladValue]
    }));
  };

  const toggleMainCourse = (courseValue) => {
    setSelections(prev => ({
      ...prev,
      mainCourses: prev.mainCourses.includes(courseValue)
        ? prev.mainCourses.filter(c => c !== courseValue)
        : [...prev.mainCourses, courseValue]
    }));
  };

  const toggleSide = (sideValue) => {
    setSelections(prev => ({
      ...prev,
      sides: prev.sides.includes(sideValue)
        ? prev.sides.filter(s => s !== sideValue)
        : [...prev.sides, sideValue]
    }));
  };

  const toggleBread = (breadValue) => {
    setSelections(prev => ({
      ...prev,
      breads: prev.breads.includes(breadValue)
        ? prev.breads.filter(b => b !== breadValue)
        : [...prev.breads, breadValue]
    }));
  };

  const toggleDessert = (dessertValue) => {
    setSelections(prev => ({
      ...prev,
      desserts: prev.desserts.includes(dessertValue)
        ? prev.desserts.filter(d => d !== dessertValue)
        : [...prev.desserts, dessertValue]
    }));
  };

  const toggleDrink = (drinkValue) => {
    setSelections(prev => ({
      ...prev,
      drinks: prev.drinks.includes(drinkValue)
        ? prev.drinks.filter(d => d !== drinkValue)
        : [...prev.drinks, drinkValue]
    }));
  };

  const toggleService = (serviceId) => {
    setSelections(prev => ({
      ...prev,
      services: prev.services.includes(serviceId)
        ? prev.services.filter(s => s !== serviceId)
        : [...prev.services, serviceId]
    }));
  };

  const calculateTotal = () => {
    let total = 0;
    if (selections.eventType === 'haat' && selections.weddingChoice === 'ready' && selections.weddingMenu) {
      const selectedMenu = weddingMenus.find(m => m.id === selections.weddingMenu);
      if (selectedMenu) total += selectedMenu.pricePerPerson * guests;
    } else {
      selections.salads.forEach(s => { if (prices.salads[s]) total += prices.salads[s] * guests; });
      selections.mainCourses.forEach(c => { if (prices.mains[c]) total += prices.mains[c] * guests; });
      selections.sides.forEach(s => { if (prices.sides[s]) total += prices.sides[s] * guests; });
      selections.breads.forEach(b => { if (prices.breads[b]) total += prices.breads[b] * guests; });
      selections.desserts.forEach(d => { if (prices.desserts[d]) total += prices.desserts[d] * guests; });
      selections.drinks.forEach(d => { if (prices.drinks[d]) total += prices.drinks[d] * guests; });
    }
    selections.services.forEach(s => {
      if (s === 'tarjoilu') total += prices.services.tarjoilu;
      else total += prices.services[s] * guests;
    });
    if (selections.delivery === true) total += prices.delivery;
    return total;
  };

  // Steps logic
  const allSteps = [
    { id: 'event', title: language === 'fi' ? 'Tilaisuus' : 'Event' },
    { id: 'guests', title: language === 'fi' ? 'Vieraat' : 'Guests' },
    { id: 'weddingChoice', title: language === 'fi' ? 'Menuvalinta' : 'Menu choice', weddingOnly: true },
    { id: 'weddingMenu', title: language === 'fi' ? 'Häämenu' : 'Wedding menu', weddingReadyOnly: true },
    { id: 'salads', title: language === 'fi' ? 'Salaatit' : 'Salads', regularOnly: true },
    { id: 'main', title: language === 'fi' ? 'Pääruoat' : 'Main courses', regularOnly: true },
    { id: 'sides', title: language === 'fi' ? 'Lisukkeet' : 'Sides', regularOnly: true },
    { id: 'breads', title: language === 'fi' ? 'Leivät' : 'Breads', regularOnly: true },
    { id: 'desserts', title: language === 'fi' ? 'Jälkiruoat' : 'Desserts', regularOnly: true },
    { id: 'drinks', title: language === 'fi' ? 'Juomat' : 'Drinks', regularOnly: true },
    { id: 'services', title: language === 'fi' ? 'Lisäpalvelut' : 'Services' },
    { id: 'delivery', title: language === 'fi' ? 'Toimitus' : 'Delivery' },
    { id: 'summary', title: language === 'fi' ? 'Yhteenveto' : 'Summary' }
  ];

  const steps = allSteps.filter(s => {
    if (s.weddingOnly && selections.eventType !== 'haat') return false;
    if (s.weddingReadyOnly && (selections.eventType !== 'haat' || selections.weddingChoice !== 'ready')) return false;
    if (s.regularOnly && selections.eventType === 'haat' && selections.weddingChoice === 'ready') return false;
    return true;
  });

  const currentStepId = steps[step]?.id;

  const canProceed = () => {
    switch(currentStepId) {
      case 'event': return selections.eventType !== '';
      case 'guests': return guests >= 10;
      case 'weddingChoice': return selections.weddingChoice !== null;
      case 'weddingMenu': return selections.weddingMenu !== null;
      case 'main': return selections.mainCourses.length > 0;
      case 'delivery': return selections.delivery !== null;
      default: return true;
    }
  };

  const resetForm = () => {
    setStep(0);
    setSelections({
      eventType: '', weddingChoice: null, weddingMenu: null, salads: [], mainCourses: [],
      sides: [], breads: [], desserts: [], drinks: [], services: [], delivery: null
    });
    setExpandedWeddingMenu(null);
    setExpandedCategory(null);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-white to-stone-100 flex flex-col items-center justify-center p-4">
      {/* Language Switcher */}
      <div className="absolute top-4 right-4 flex items-center gap-2">
        <button
          onClick={() => setLanguage('fi')}
          className={`w-8 h-6 rounded overflow-hidden border-2 transition-all ${language === 'fi' ? 'border-amber-500 scale-110' : 'border-transparent opacity-60 hover:opacity-100'}`}
          title="Suomi"
        >
          <svg viewBox="0 0 1800 1100" className="w-full h-full">
            <rect fill="#fff" width="1800" height="1100"/>
            <rect fill="#003580" y="400" width="1800" height="300"/>
            <rect fill="#003580" x="500" width="300" height="1100"/>
          </svg>
        </button>
        <button
          onClick={() => setLanguage('en')}
          className={`w-8 h-6 rounded overflow-hidden border-2 transition-all ${language === 'en' ? 'border-amber-500 scale-110' : 'border-transparent opacity-60 hover:opacity-100'}`}
          title="English"
        >
          <svg viewBox="0 0 60 30" className="w-full h-full">
            <clipPath id="s"><path d="M0,0 v30 h60 v-30 z"/></clipPath>
            <clipPath id="t"><path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z"/></clipPath>
            <g clipPath="url(#s)">
              <path d="M0,0 v30 h60 v-30 z" fill="#012169"/>
              <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6"/>
              <path d="M0,0 L60,30 M60,0 L0,30" clipPath="url(#t)" stroke="#C8102E" strokeWidth="4"/>
              <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10"/>
              <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6"/>
            </g>
          </svg>
        </button>
      </div>

      {/* Calculator */}
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-2xl border border-amber-200 overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-amber-500 to-amber-600 px-6 py-4">
            <div className="flex items-center justify-between text-white">
              <span className="text-sm font-medium">{t.title}</span>
              <span className="text-sm bg-white/20 px-3 py-1 rounded-full">
                {step + 1}/{steps.length}
              </span>
            </div>
            <div className="mt-2 h-1.5 bg-white/30 rounded-full">
              <div 
                className="h-full bg-white rounded-full transition-all duration-300"
                style={{ width: `${((step + 1) / steps.length) * 100}%` }}
              />
            </div>
          </div>

          {/* Content */}
          <div className="p-6 min-h-[300px]">
            {/* Event Type */}
            {currentStepId === 'event' && (
              <div className="space-y-4">
                <h3 className="font-semibold text-stone-800">{t.eventQuestion}</h3>
                <div className="grid grid-cols-2 gap-2">
                  {eventTypes.map(event => (
                    <button
                      key={event.value}
                      onClick={() => setSelections(prev => ({ ...prev, eventType: event.value, weddingMenu: null }))}
                      className={`p-3 rounded-xl border text-center transition-all cursor-pointer text-sm ${
                        selections.eventType === event.value
                          ? 'border-amber-500 bg-amber-50 text-stone-800 font-medium'
                          : 'border-stone-200 bg-stone-50 text-stone-600 hover:border-amber-300'
                      }`}
                    >
                      {event.label}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* Guests */}
            {currentStepId === 'guests' && (
              <div className="space-y-4">
                <h3 className="font-semibold text-stone-800">{t.guestsQuestion}</h3>
                <div className="flex items-center gap-4">
                  <input
                    type="range"
                    min="10"
                    max="200"
                    value={guests}
                    onChange={(e) => setGuests(parseInt(e.target.value))}
                    className="flex-1 h-2 bg-stone-200 rounded-lg appearance-none cursor-pointer accent-amber-500"
                  />
                  <span className="text-2xl font-bold text-amber-600 min-w-[60px] text-right">{guests}</span>
                </div>
                <p className="text-sm text-stone-500">{t.minGuests}</p>
              </div>
            )}

            {/* Wedding Choice */}
            {currentStepId === 'weddingChoice' && (
              <div className="space-y-4">
                <div className="flex items-center gap-2">
                  <Sparkles className="w-5 h-5 text-amber-500" />
                  <h3 className="font-semibold text-stone-800">{t.menuChoice}</h3>
                </div>
                <p className="text-sm text-stone-500">{t.menuChoiceDesc}</p>
                <div className="space-y-3">
                  <button
                    onClick={() => setSelections(prev => ({ ...prev, weddingChoice: 'ready' }))}
                    className={`w-full p-4 rounded-xl border-2 text-left transition-all cursor-pointer ${
                      selections.weddingChoice === 'ready' ? 'border-amber-500 bg-amber-50' : 'border-stone-200 hover:border-amber-300'
                    }`}
                  >
                    <span className="font-bold block">{t.readyMenu}</span>
                    <p className="text-xs text-stone-500">{t.readyMenuDesc}</p>
                  </button>
                  <button
                    onClick={() => setSelections(prev => ({ ...prev, weddingChoice: 'custom', weddingMenu: null }))}
                    className={`w-full p-4 rounded-xl border-2 text-left transition-all cursor-pointer ${
                      selections.weddingChoice === 'custom' ? 'border-amber-500 bg-amber-50' : 'border-stone-200 hover:border-amber-300'
                    }`}
                  >
                    <span className="font-bold block">{t.customMenu}</span>
                    <p className="text-xs text-stone-500">{t.customMenuDesc}</p>
                  </button>
                </div>
              </div>
            )}

            {/* Wedding Menu */}
            {currentStepId === 'weddingMenu' && (
              <div className="space-y-4">
                <h3 className="font-semibold text-stone-800">{t.selectWeddingMenu}</h3>
                <p className="text-sm text-stone-500">{t.weddingMenuDesc}</p>
                <div className="space-y-3">
                  {weddingMenus.map((menu) => (
                    <div key={menu.id} className={`rounded-xl border-2 overflow-hidden ${
                      selections.weddingMenu === menu.id ? 'border-amber-500 bg-amber-50' : 'border-stone-200'
                    }`}>
                      <button
                        onClick={() => {
                          setSelections(prev => ({ ...prev, weddingMenu: menu.id }));
                          setExpandedWeddingMenu(expandedWeddingMenu === menu.id ? null : menu.id);
                        }}
                        className="w-full p-3 flex items-center justify-between text-left"
                      >
                        <div>
                          <span className="font-bold text-sm block">{menu.name}</span>
                          <p className="text-xs text-stone-500">{menu.description}</p>
                          <p className="text-xs text-amber-600 font-semibold mt-1">{menu.pricePerPerson}€{t.perPerson}</p>
                        </div>
                        <ChevronDown className={`w-4 h-4 text-stone-400 transition-transform ${expandedWeddingMenu === menu.id ? 'rotate-180' : ''}`} />
                      </button>
                      {expandedWeddingMenu === menu.id && (
                        <div className="px-3 pb-3 border-t border-stone-200">
                          <ul className="text-xs text-stone-600 mt-2 space-y-1">
                            {menu.items.map((item, i) => <li key={i}>• {item}</li>)}
                          </ul>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Salads */}
            {currentStepId === 'salads' && (
              <div className="space-y-4">
                <h3 className="font-semibold text-stone-800">{t.selectSalads}</h3>
                <p className="text-sm text-stone-500">{t.selectMultiple}</p>
                <div className="grid grid-cols-2 gap-2">
                  {saladOptions.map(salad => (
                    <button
                      key={salad.value}
                      onClick={() => toggleSalad(salad.value)}
                      className={`p-3 rounded-xl border text-center transition-all cursor-pointer text-sm ${
                        selections.salads.includes(salad.value)
                          ? 'border-amber-500 bg-amber-50 font-medium'
                          : 'border-stone-200 bg-stone-50 hover:border-amber-300'
                      }`}
                    >
                      {salad.label}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* Main Courses */}
            {currentStepId === 'main' && (
              <div className="space-y-4">
                <h3 className="font-semibold text-stone-800">{t.selectMainCourse}</h3>
                <p className="text-sm text-stone-500">{t.mainCourseDesc} - {t.selectMultiple}</p>
                <div className="space-y-2 max-h-[200px] overflow-y-auto">
                  {mainCourseCategories.map(category => {
                    const isExpanded = expandedCategory === category.id;
                    const selectedCount = selections.mainCourses.filter(c => 
                      category.dishes.some(d => d.value === c)
                    ).length;
                    return (
                      <div key={category.id} className={`rounded-xl border-2 overflow-hidden ${
                        selectedCount > 0 ? 'border-amber-500 bg-amber-50/50' : 'border-stone-200'
                      }`}>
                        <button
                          onClick={() => setExpandedCategory(isExpanded ? null : category.id)}
                          className="w-full p-3 flex items-center justify-between text-left"
                        >
                          <div className="flex items-center gap-2">
                            <span className="font-semibold text-sm">{category.label}</span>
                            {selectedCount > 0 && (
                              <span className="text-xs bg-amber-500 text-white px-2 py-0.5 rounded-full">{selectedCount}</span>
                            )}
                          </div>
                          <ChevronDown className={`w-4 h-4 text-stone-400 transition-transform ${isExpanded ? 'rotate-180' : ''}`} />
                        </button>
                        {isExpanded && (
                          <div className="px-3 pb-3 border-t border-stone-200 bg-white/50">
                            <div className="pt-3 grid grid-cols-1 gap-2">
                              {category.dishes.map(dish => (
                                <button
                                  key={dish.value}
                                  onClick={() => toggleMainCourse(dish.value)}
                                  className={`p-2 rounded-lg border text-left transition-all cursor-pointer text-sm ${
                                    selections.mainCourses.includes(dish.value)
                                      ? 'border-amber-500 bg-amber-100 font-medium'
                                      : 'border-stone-200 bg-stone-50 hover:border-amber-300'
                                  }`}
                                >
                                  <div className="flex items-center justify-between">
                                    <span>{dish.label}</span>
                                    {selections.mainCourses.includes(dish.value) && <CheckCircle className="w-4 h-4 text-amber-600" />}
                                  </div>
                                </button>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {/* Sides */}
            {currentStepId === 'sides' && (
              <div className="space-y-4">
                <h3 className="font-semibold text-stone-800">{t.selectSides}</h3>
                <p className="text-sm text-stone-500">{t.sidesDesc}</p>
                <div className="grid grid-cols-2 gap-2">
                  {sideOptions.map(side => (
                    <button
                      key={side.value}
                      onClick={() => toggleSide(side.value)}
                      className={`p-3 rounded-xl border text-center transition-all cursor-pointer text-sm ${
                        selections.sides.includes(side.value)
                          ? 'border-amber-500 bg-amber-50 font-medium'
                          : 'border-stone-200 bg-stone-50 hover:border-amber-300'
                      }`}
                    >
                      {side.label}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* Breads */}
            {currentStepId === 'breads' && (
              <div className="space-y-4">
                <h3 className="font-semibold text-stone-800">{t.selectBreads}</h3>
                <p className="text-sm text-stone-500">{t.breadsDesc}</p>
                <div className="grid grid-cols-2 gap-2">
                  {breadOptions.map(bread => (
                    <button
                      key={bread.value}
                      onClick={() => toggleBread(bread.value)}
                      className={`p-3 rounded-xl border text-center transition-all cursor-pointer text-sm ${
                        selections.breads.includes(bread.value)
                          ? 'border-amber-500 bg-amber-50 font-medium'
                          : 'border-stone-200 bg-stone-50 hover:border-amber-300'
                      }`}
                    >
                      {bread.label}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* Desserts */}
            {currentStepId === 'desserts' && (
              <div className="space-y-4">
                <h3 className="font-semibold text-stone-800">{t.dessertQuestion}</h3>
                <p className="text-sm text-stone-500">{t.selectMultiple}</p>
                <div className="grid grid-cols-2 gap-2">
                  {dessertOptions.map(dessert => (
                    <button
                      key={dessert.value}
                      onClick={() => toggleDessert(dessert.value)}
                      className={`p-3 rounded-xl border text-center transition-all cursor-pointer text-sm ${
                        selections.desserts.includes(dessert.value)
                          ? 'border-amber-500 bg-amber-50 font-medium'
                          : 'border-stone-200 bg-stone-50 hover:border-amber-300'
                      }`}
                    >
                      {dessert.label}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* Drinks */}
            {currentStepId === 'drinks' && (
              <div className="space-y-4">
                <h3 className="font-semibold text-stone-800">{t.drinksQuestion}</h3>
                <p className="text-sm text-stone-500">{t.selectMultiple}</p>
                <div className="grid grid-cols-2 gap-2">
                  {drinkOptions.map(drink => (
                    <button
                      key={drink.value}
                      onClick={() => toggleDrink(drink.value)}
                      className={`p-3 rounded-xl border text-center transition-all cursor-pointer text-sm ${
                        selections.drinks.includes(drink.value)
                          ? 'border-amber-500 bg-amber-50 font-medium'
                          : 'border-stone-200 bg-stone-50 hover:border-amber-300'
                      }`}
                    >
                      {drink.label}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* Services */}
            {currentStepId === 'services' && (
              <div className="space-y-4">
                <h3 className="font-semibold text-stone-800">{t.additionalServices}</h3>
                <div className="space-y-2">
                  {serviceOptions.map(service => (
                    <button
                      key={service.id}
                      onClick={() => toggleService(service.id)}
                      className={`w-full p-3 rounded-xl border text-center transition-all cursor-pointer text-sm ${
                        selections.services.includes(service.id)
                          ? 'border-amber-500 bg-amber-50 font-medium'
                          : 'border-stone-200 bg-stone-50 hover:border-amber-300'
                      }`}
                    >
                      {service.label}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* Delivery */}
            {currentStepId === 'delivery' && (
              <div className="space-y-4">
                <h3 className="font-semibold text-stone-800">{t.deliveryQuestion}</h3>
                <p className="text-sm text-stone-500">{t.deliveryDesc}</p>
                <div className="grid grid-cols-2 gap-3">
                  <button
                    onClick={() => setSelections(prev => ({ ...prev, delivery: true }))}
                    className={`p-4 rounded-xl border text-center transition-all cursor-pointer ${
                      selections.delivery === true ? 'border-amber-500 bg-amber-50 font-medium' : 'border-stone-200 bg-stone-50 hover:border-amber-300'
                    }`}
                  >
                    <span className="block text-lg mb-1">{t.yes}</span>
                    <span className="text-xs text-stone-500">+50€</span>
                  </button>
                  <button
                    onClick={() => setSelections(prev => ({ ...prev, delivery: false }))}
                    className={`p-4 rounded-xl border text-center transition-all cursor-pointer ${
                      selections.delivery === false ? 'border-amber-500 bg-amber-50 font-medium' : 'border-stone-200 bg-stone-50 hover:border-amber-300'
                    }`}
                  >
                    <span className="block text-lg mb-1">{t.no}</span>
                    <span className="text-xs text-stone-500">{t.pickup}</span>
                  </button>
                </div>
              </div>
            )}

            {/* Summary */}
            {currentStepId === 'summary' && (
              <div className="space-y-4">
                <h3 className="font-semibold text-stone-800">{t.summary}</h3>
                <div className="bg-amber-50 rounded-xl p-4 space-y-2 border border-amber-100">
                  <div className="flex justify-between text-sm">
                    <span className="text-stone-600">{t.eventType}</span>
                    <span className="text-stone-800 font-medium">
                      {eventTypes.find(e => e.value === selections.eventType)?.label || '-'}
                    </span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-stone-600">{t.guestCount}</span>
                    <span className="text-stone-800 font-medium">{guests} {t.persons}</span>
                  </div>
                  {selections.salads.length > 0 && (
                    <div className="flex justify-between text-sm">
                      <span className="text-stone-600">{t.salads}</span>
                      <span className="text-stone-800 font-medium">{selections.salads.length} {t.pcs}</span>
                    </div>
                  )}
                  {selections.mainCourses.length > 0 && (
                    <div className="flex justify-between text-sm">
                      <span className="text-stone-600">{t.mainCourse}</span>
                      <span className="text-stone-800 font-medium">{selections.mainCourses.length} {t.pcs}</span>
                    </div>
                  )}
                  {selections.sides.length > 0 && (
                    <div className="flex justify-between text-sm">
                      <span className="text-stone-600">{t.sides}</span>
                      <span className="text-stone-800 font-medium">{selections.sides.length} {t.pcs}</span>
                    </div>
                  )}
                  {selections.breads.length > 0 && (
                    <div className="flex justify-between text-sm">
                      <span className="text-stone-600">{t.breads}</span>
                      <span className="text-stone-800 font-medium">{selections.breads.length} {t.pcs}</span>
                    </div>
                  )}
                  {selections.desserts.length > 0 && (
                    <div className="flex justify-between text-sm">
                      <span className="text-stone-600">{t.dessert}</span>
                      <span className="text-stone-800 font-medium">{selections.desserts.length} {t.pcs}</span>
                    </div>
                  )}
                  {selections.drinks.length > 0 && (
                    <div className="flex justify-between text-sm">
                      <span className="text-stone-600">{t.drinks}</span>
                      <span className="text-stone-800 font-medium">{selections.drinks.length} {t.pcs}</span>
                    </div>
                  )}
                  <div className="flex justify-between text-sm">
                    <span className="text-stone-600">{t.delivery}</span>
                    <span className="text-stone-800 font-medium">
                      {selections.delivery === true ? `${t.yes} (+50€)` : t.pickup}
                    </span>
                  </div>
                  <div className="border-t border-amber-200 pt-3 mt-3">
                    <div className="flex justify-between">
                      <span className="font-semibold text-stone-800">{t.total}</span>
                      <span className="text-2xl font-bold text-amber-600">{calculateTotal().toFixed(0)}€</span>
                    </div>
                  </div>
                </div>
                <p className="text-xs text-stone-500 text-center">{t.demoNote}</p>
              </div>
            )}
          </div>

          {/* Footer */}
          <div className="px-6 py-4 border-t border-stone-100 bg-stone-50 flex items-center justify-between">
            <button
              onClick={() => setStep(Math.max(0, step - 1))}
              disabled={step === 0}
              className="px-4 py-2 text-sm text-stone-500 hover:text-stone-800 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              {t.previous}
            </button>
            {step < steps.length - 1 ? (
              <button
                onClick={() => setStep(step + 1)}
                disabled={!canProceed()}
                className="bg-amber-500 hover:bg-amber-600 text-white font-semibold rounded-xl px-6 py-2.5 text-sm disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer flex items-center gap-2 transition-colors"
              >
                {t.next}
                <ArrowRight className="w-4 h-4" />
              </button>
            ) : (
              <button
                onClick={resetForm}
                className="bg-amber-500 hover:bg-amber-600 text-white font-semibold rounded-xl px-6 py-2.5 text-sm cursor-pointer transition-colors"
              >
                {t.startOver}
              </button>
            )}
          </div>
        </div>

        {/* Powered by */}
        <div className="text-center mt-4 text-stone-400 text-sm">
          {t.poweredBy}{' '}
          <a href="/" className="text-amber-600 hover:text-amber-700 font-medium">
            JuhlaLaskuri
          </a>
        </div>
      </div>
    </div>
  );
};

export default DemoOnlyPage;
